import { ENDPOINTS } from 'utils/api/callApi'
import { generateApiActionTypes } from './generateActionTypes'

interface IGetScheduleStopParams {
  autoConfirmToken?: string
  shipperId?: string
  stopType?: string
  facilityUuid?: string
}

export const SCHEDULE_STOPS_ACTION_TYPES = generateApiActionTypes('SCHEDULE_STOPS')

export const getScheduleStops = (params: IGetScheduleStopParams) => {
  const { autoConfirmToken, facilityUuid, shipperId, stopType } = params || {}

  const query = {
    auto_confirm_token: autoConfirmToken,
    shipper_application_id: shipperId,
    stop_type: stopType,
  }

  const requestData = {
    endpoint: ENDPOINTS.facilities,
    id: facilityUuid,
    skipErrorPrefix: true,
    group: 'schedule_stops',
    params: query,
    method: 'GET',
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SCHEDULE_STOPS_ACTION_TYPES),
    },
    type: '',
  }
}
